"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getFromBounding = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _lodash = _interopRequireDefault(require("lodash.debounce"));

var _lodash2 = _interopRequireDefault(require("lodash.get"));

var _useStyles2 = _interopRequireDefault(require("./useStyles"));

var _DropdownNavigation = _interopRequireDefault(require("./DropdownNavigation"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var getFromBounding = function getFromBounding(el, attribute) {
  return (0, _lodash2["default"])(el.getBoundingClientRect(), attribute);
};

exports.getFromBounding = getFromBounding;

var getHeight = function getHeight(el) {
  return getFromBounding(el, 'height');
};

var getTop = function getTop(el) {
  return getFromBounding(el, 'top');
};

var Blinds = function Blinds(_ref) {
  var items = _ref.items;

  var _React$useState = _react["default"].useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      height = _React$useState2[0],
      setHeight = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(0),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      restingHeight = _React$useState4[0],
      setRestingHeight = _React$useState4[1];

  var _useStyles = (0, _useStyles2["default"])({
    isOpen: restingHeight < height,
    height: height
  }),
      ul = _useStyles.ul,
      nav = _useStyles.nav,
      overlay = _useStyles.overlay;

  var init = _react["default"].useCallback(function (el) {
    if (!el) return;
    var h = getHeight(el);
    setRestingHeight(h);
    setHeight(h);
  }, []);

  var onRefChange = _react["default"].useCallback(function (node) {
    setHeight(node ? getHeight(node) + getTop(node) : restingHeight);
  }, [height]);

  var resetDropdown = (0, _lodash["default"])(function () {
    setHeight(0);
  }, 100);

  _react["default"].useLayoutEffect(function () {
    window.addEventListener('scroll', resetDropdown);
    return function () {
      window.removeEventListener('scroll', resetDropdown);
    };
  }, []);

  return /*#__PURE__*/_react["default"].createElement("nav", {
    ref: init,
    className: nav
  }, /*#__PURE__*/_react["default"].createElement(_core.Box, {
    bgcolor: "background.paper",
    className: overlay,
    position: "fixed",
    width: "100%"
  }), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    component: "ul",
    className: ul,
    spacing: 5
  }, items.map(function (x, i) {
    return /*#__PURE__*/_react["default"].createElement(_DropdownNavigation["default"], {
      key: typeof x.main === 'string' ? x.main.concat(i) : "dropdownNav".concat(i),
      ref: onRefChange,
      item: x
    });
  })));
};

Blinds.propTypes = {
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    href: _propTypes["default"].string,
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      label: _propTypes["default"].string.isRequired,
      href: _propTypes["default"].string.isRequired
    }))
  })).isRequired
};
var _default = Blinds;
exports["default"] = _default;